/* eslint-disable max-len */
/* eslint-disable max-len */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import userService from '../../services/user.services'

// const user = JSON.parse(sessionStorage.getItem('user'));
// const initial = user ? true : false;

const initialState = {
    user: '',
    loading: true,
    initial_loading: false,
    error: '',
    success: '',
    access_token: '',
    email: '',
    loggedIn: false
}
export const loginUser = createAsyncThunk('user', async (body) => {
    // let res = await userService.login(body.email, body.password);
    // return res
})
const authSlice = createSlice({

    name: 'user',
    initialState,
    reducers: {
        addToken: (state, action) => {
            state.token = sessionStorage.getItem('token')
        },
        addUser: (state, action) => {
            state.token = sessionStorage.getItem('user')
        },
        verifyOtp: (state, action) => {
            state.loggedIn = true
            state.email = action.payload
        },
        logIn: (state, action) => {
            state.loggedIn = true
            state.email = action.payload
        },
        setUserType: (state, action) => {
            if (action.payload.branches) {
                state.userType = action.payload.userType
                state.branches = action.payload.branches

            } else {
                state.userType = action.payload

            }
            state.initial_loading = false

        },
        handleClockIn: (state, action) => {
            state.clock_in_out_facitilty = action.payload
        },
        handleLoading: (state, action) => {

            state.initial_loading = action.payload
        },
        logout: (state, action) => {
            sessionStorage.clear()
            state.loggedIn = false
            state.email = '';
            state.userType = ''
        },
        updateAuth: (state, action) => {
            state.user = action.payload
        },

    },
    extraReducers: {
        // register user
        [loginUser.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [loginUser.fulfilled]: (state, action) => {
            state.loading = false;
            state.email = action.meta.arg.email
            if (!action.payload.error && action?.payload?.data?.success_status) {
                state.success = action?.payload?.data?.message;
                if (action.payload?.data?.access_token !== '') {
                    state.access_token = action?.payload?.data?.access_token
                } else {
                    state.error = 'Failed'
                }

                state.error = action.payload.message?.message
            } else {
                state.error = action?.payload?.data?.message

            }
        },
        [loginUser.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { addToken, addUser, verifyOtp, logIn, updateAuth, logout, setUserType, handleLoading, handleClockIn } = authSlice.actions;
export default authSlice.reducer